import { EPricing, EProduct } from "@canei/app-components";
import { IPricing, IRenderRules } from "../../../@types";

export enum ECountry {
  AUT = "AUT",
  DEU = "DEU",
  CHE = "CHE",
}

export interface ICustomerData {
  customer_id: string;
  product_id: EProduct;
  pricing_id: EPricing;
  status: string;
  start_date: number;
  trial_end: number;
  features: IFeatures[];
  canceled_at?: number;
  billing_address?: IBillingDetailedAddress;
  payment_method?: PaymentMethod;
}

export interface IBillingDetailedAddress {
  line_1?: string;
  line_2?: string;
  city?: string;
  email?: string;
  telephone?: string;
  postal?: string;
  country?: ECountry | string;
  name?: string;
  vat_id?: string;
}
export interface PaymentMethod {
  type?: string;
  last_four?: string;
  brand?: string;
  bank_code?: string;
  exp_month?: number;
  exp_year?: number;
}

export interface IGetCustomerStatus {
  customerData: ICustomerData;
}

export interface IGetRenderRules {
  renderRules: IRenderRules[];
}

export interface IGetCouponList {
  getCouponList: {
    campaigns: ICoupon[];
  };
}

export interface IGetFeaturesData {
  getFeaturesData: IFeaturesDataRetVal;
}

export interface IFeaturesDataRetVal {
  bundleTree: ITreeData[];
  productFeatureTree: ITreeData[];
}

export interface ITreeData {
  value: string;
  tree: ITreeValue[];
}

export interface ITreeValue {
  disabled?: boolean;
  value: string;
  key?: string;
  type?: string;
}
export interface IComponentsData {
  value: string;
  type: string;
  key: string;
}

export interface IPromotionsDataRetVal {
  promoFeatures: IGetPromotionsData[];
}

export interface IGetPromotionsData {
  feature_id: string;
  trial_end: number;
  tree?: ITreeValue[];
  status?: string;
  canceled_at?: number;
  tree?: ITreeValue[];
}

export interface ICoupon {
  coupon_id: string;
  product_id: string;
  end_time: string;
  start_time: string;
  pricing_id: string;
  trial_days: number;
  price: number;
  features: IFeaturesInfo[];
  dynamic: boolean;
}

export interface IFeaturesInfo {
  feature_id: string;
  pricing_id: string;
  price: number;
}

export interface IFeatures {
  feature_id: string;
  pricing_id: string;
  status: string;
  start_date: number;
  trial_end: number;
  canceled_at: number;
}

export interface IGetAllPricings {
  pricings: IPricing[];
}

export interface ISubscriptionData {
  result?: ISubscription[];
}
export interface ISubscriptionVars {
  customer_id: string;
}

export interface IUpdateBillingAddressVars {
  params: IBillingDetailedAddress;
  customer_id: string;
}

export interface IUpdateBillingAddressRetVal {
  updateBillingAddress: IBillingDetailedAddress;
}
